import Phaser, { AUTO } from 'phaser';
import { CST } from '../CST';

export default class Preload extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.PRELOAD);
	}

	preload() {
		this.add.image(this.cameras.main.width / 2, this.cameras.main.height / 2, 'loading-bg');

		// Hide the HTML overlay now that Phaser is rendering the loading screen on canvas
		var overlay = document.getElementById('loading-overlay');
		if (overlay) overlay.style.display = 'none';

		// UI backgrounds (needed from the very first screens)
		this.load.image('menu-bg', 'assets/start-screen.webp');
		this.load.image('desktop-bg', 'assets/desktop-mode.webp');
		this.load.image('black-bg', 'assets/black-screen.webp');
		this.load.image('credits-bg', 'assets/credits_screen.webp');
		this.load.image('rules-bg', 'assets/rules_screen.webp');
		this.load.image('main-storyboard-bg', 'assets/Storyboards/dementia_intro_background.webp');
		this.load.image('select-story-bg', 'assets/Storyboards/select_story_background.webp');
		this.load.image(
			'select-story-finish-bg',
			'assets/Storyboards/story-selection-screen-finished.webp',
		);
		// Story-specific backgrounds are loaded in their respective storyboard scenes

		// Shared UI buttons (used by UIScene and multiple early scenes)
		this.load.image('menu-btn', 'assets/Buttons/menu.webp');
		this.load.image('next-btn', 'assets/Buttons/Next.webp');
		this.load.image('previous-btn', 'assets/Buttons/Previous.webp');
		this.load.image('pause-btn', 'assets/Buttons/Pause.webp');
		this.load.image('play-btn', 'assets/Buttons/play.webp');
		this.load.image('rules-btn', 'assets/Buttons/rules.webp');
		this.load.image('settings-btn', 'assets/Buttons/Settings.webp');
		this.load.image('correct-pop', 'assets/Buttons/Correct.webp');
		this.load.image('incorrect-pop', 'assets/Buttons/Incorrect.webp');
		this.load.image('credits-btn', 'assets/Buttons/credits.webp');
		this.load.image('home-btn', 'assets/Buttons/home.webp');
		this.load.image('sound-on-btn', 'assets/Buttons/sound on.webp');
		this.load.image('sound-off-btn', 'assets/Buttons/sound off.webp');
		this.load.image('feedback-btn', 'assets/Buttons/feedback.webp');
		this.load.image('certificate-btn', 'assets/Buttons/certificate.webp');
		this.load.image('score-box', 'assets/Buttons/Scores.webp');
		this.load.image('end-btn', 'assets/Buttons/end.webp');
		// Story-selection button spritesheets are loaded in story-select.js preload()
		// Minigame assets are loaded in their respective scene preload() methods
		// Questionnaire assets are loaded in form.js preload()
		// EndScreen popup assets are loaded in endscreen.js preload()

		// Shared sounds (used from Menu onwards)
		this.load.audio('click-sound', 'assets/Sounds/click-sound.mp3');
		this.load.audio('main-soundtrack', 'assets/Sounds/2. bensound-dreams_trimmed.mp3');
		// Minigame sounds (clock, correct, wrong, congratulations, pop2, minigame-soundtrack)
		// are loaded in their respective minigame scene preload() methods

		if (
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
		) {
			this.load.on('complete', () => {
				this.scene.start(CST.SCENES.POPUP);
			});
		} else {
			this.load.on('complete', () => {
				this.scene.start(CST.SCENES.MENU);
			});
		}
	}
}
